import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=b3bd067c&scoped=true&"
import script from "./SelectBox.vue?vue&type=script&lang=ts&"
export * from "./SelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=b3bd067c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bd067c",
  null
  
)

export default component.exports